var map = {
	"./about-card.de-CH.json": 1355,
	"./about-card.de-DE.json": 1356,
	"./about-card.en-CA.json": 1357,
	"./about-card.en-GB.json": 1358,
	"./about-card.en-IN.json": 1359,
	"./about-card.en-ME.json": 1360,
	"./about-card.en-US.json": 1361,
	"./about-card.es-EM.json": 1362,
	"./about-card.es-ES.json": 1363,
	"./about-card.fr-BE.json": 1364,
	"./about-card.fr-CA.json": 1365,
	"./about-card.fr-CH.json": 1366,
	"./about-card.nl-BE.json": 1367,
	"./about-card.nl-NL.json": 1368,
	"./about-card.pl-PL.json": 1369,
	"./about-card.pt-BR.json": 1370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1354;